import { JsonValue } from "hassibot/services_v2/common/types";
import { RegisterDeviceResponse } from "hassibot/services_v2/login/types";

export const registerDeviceReader = (json: JsonValue): RegisterDeviceResponse => ({
  deviceId: json.deviceId,
  pushToken: json.pushToken,
  isPushTokenValid: json.isPushTokenValid,
});
